module.exports = __webpack_public_path__ + "static/Scotch-596dd9742e277271aa73ed84c1fc46cc.svg";